import {ProviderModel} from './ProviderModel';
import {RegionModel} from './RegionModel';
import {LocalCustomerModel} from './LocalCustomerModel';
import {ContractTypeModel} from './ContractTypeModel';
import {CurrencyModel} from './CurrencyModel';
import {ServiceVariantModel} from './ServiceVariantModel';
import {SizeModel} from './SizeModel';

export class ReimbursmentModel {

  numAnnoMese: number;
  provider: ProviderModel;
  region: RegionModel;
  localCustomer: LocalCustomerModel;
  contractType: ContractTypeModel;
  serviceVariant: ServiceVariantModel;
  currency: CurrencyModel;
  size: SizeModel;
  compensationPayment: number;


  constructor(numAnnoMese?: number, provider?: ProviderModel, region?: RegionModel, localCustomer?: LocalCustomerModel, contractType?: ContractTypeModel,
    serviceVariant?: ServiceVariantModel, currency?: CurrencyModel, size?: SizeModel, compensationPayment?: number) {
    this.numAnnoMese = numAnnoMese;
    this.provider = provider;
    this.region = region;
    this.localCustomer = localCustomer;
    this.contractType = contractType;
    this.serviceVariant = serviceVariant;
    this.currency = currency;
    this.size = size;
    this.compensationPayment = compensationPayment;
  }

  public static clone(obj: ReimbursmentModel): ReimbursmentModel {
    const result: ReimbursmentModel = new ReimbursmentModel();
    result.localCustomer = obj.localCustomer;
    result.region = obj.region;
    result.serviceVariant = obj.serviceVariant;

    return result;
  }
}

export class ReimbursmentReportModel extends  ReimbursmentModel {
  numAnnoMeseFrom: number;
  numAnnoMeseTo: number;
}
